<template>
    <div class="custom_list">
        <Popup ref="popupEdit" class="popup-edit">
            <PopupEdit :path="path" :id="id" :defaultData="defaultData" @close="closePopupEdit" @refresh="fetchData"/>
        </Popup>
        <div class="content">
            <div class="action-btn">
                <div v-if="currentSetting.action && currentSetting.action.includes('create')">
                    <el-button @click="create" type="primary" size="mini" v-if="hasRightToCreate">{{ $t("button.create") }}</el-button>
                </div>
            </div>
            <div class="tab-content">
                <vxe-table
                ref="table"
                class="main-table"
                size="mini"
                border
                show-header-overflow
                show-overflow
                highlight-hover-row
                :empty-text="$t('label.no_data_found')"
                @filter-change="filterChanged"
                @sort-change="sortChanged"
                :remote-sort="true"
                @cell-click="clickedCell"
                :loading="loading"
                :key="new Date().getTime()"
                :resizable="true"
                :data="tableData">

                <vxe-table-column
                    v-for="(field) in currentSetting.fields" :key="field.key"
                    :field="field.key"
                    :title="field.key"
                    :filters="field.type != 'action-btn' && currentSetting.filters && currentSetting.filters.hasOwnProperty(field.key) ? [currentSetting.filters[field.key].hasOwnProperty('type') && ['select','multiselect'].includes(currentSetting.filters[field.key].type) ? false : ''] : null"
                    :filter-render="filterRender(field.key)"
                    :filter-change="filterChanged"
                    :class-name="shouldHighlight"
                    :sortable="currentSetting.sort_fields ? currentSetting.sort_fields.includes(field.key) : false"
                    :width="field.width"
                >
                    <template v-slot:header="{ columnIndex }">
                    <div class="detect-block"
                        @mouseover.stop="onFilterMouseOver(currentSetting.fields[columnIndex].key)"
                    ></div>
                    <div class="header-wrap">
                        <div class="name">
                        {{ tran(key, currentSetting.fields[columnIndex].key) }}
                        </div>
                        <!-- <div class="filter-value">{{ filter.hasOwnProperty(field.key) ? getFilterValue(field) : "" }}</div> -->
                    </div>
                    </template>
                    <template v-slot="{ row }">
                    <div v-if="field.type == 'boolean'">
                        <el-checkbox :checked="row[field.key] == 1"/>
                        <div class="block-layer"></div>
                    </div>

                    <div v-else-if="field.type == 'datetime'">
                        {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD HH:mm:ss") : field.fill ? $moment().format("YYYY-MM-DD HH:mm:ss") : "" }}
                    </div>

                    <div v-else-if="field.type == 'date'">
                        {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD") : field.fill ? $moment().format("YYYY-MM-DD") : "" }}
                    </div>
                    <Component :is="field.component" v-else-if="field.type == 'componentColumn'" :k="key" :action="'List'" :field="field" :data="row" @needUpdate="fetchData" :ref="`componentColumn-${field.key}`" :options="options" :row="row"/>

                    <div v-else-if="field.type == 's_to_hms'">
                        {{ row[field.key] ? getTime(row[field.key]) : "00:00:00" }}
                    </div>
                    <div v-else-if="field.type == 'href'">
                        <a v-if="row[field.key]" :href="hrefUrl(row, field)" >{{row[field.key]}}</a>
                    </div>

                    <div v-else-if="field.type == 'components'">
                        <component class="component" :is="field.component" :data="row"></component>
                    </div>

                    <div class="action" v-else-if="field.type == 'action-btn' && currentSetting.action.length > 0">
                        <div v-if="trashMode==0">
                            <el-button
                            type="info"
                            size="mini"
                            @click="$router.push({ name: 'View', params: { id: currentSetting.id ? row[currentSetting.id] : row.id } })"
                            v-if="currentSetting.action.includes('view')"
                            >
                            <fa :icon="['fas', 'list-alt']"/>
                            </el-button>
                        <el-button
                            type="primary"
                            size="mini"
                            @click="edit(currentSetting.id ? row[currentSetting.id] : row.id)"
                            v-if="hasRightToEdit"
                        >
                            <fa :icon="['fas', 'pen']"/>
                        </el-button>
                        <el-button
                            type="info"
                            size="mini"
                            @click="popupDetails(currentSetting.id ? row[currentSetting.id] : row.id)"
                            v-if="currentSetting.action.includes('pop-view')"
                        >
                            <fa :icon="['fas', 'list-alt']"/>
                        </el-button>
                        <el-button
                            type="info"
                            size="mini"
                            @click="downloadPdf(currentSetting.id ? row[currentSetting.id] : row.id)"
                            v-if="currentSetting.action.includes('download-pdf')"
                        >
                            <fa :icon="['fas', 'download']"/>
                        </el-button>
                        <el-button
                            type="info"
                            size="mini"
                            @click="clickedDelete(currentSetting.id ? row[currentSetting.id] : row.id)"
                            v-if="hasRightToDelete"
                        >
                            <fa :icon="['fas', 'trash-alt']"/>
                        </el-button>
                        </div>
                        <div v-else>
                        <el-button type="warning" size="mini" @click="clickedChangeActive(row.id, 1)">
                            <fa :icon="['fas', 'undo-alt']"/>
                        </el-button>
                        <el-button type="danger" size="mini" @click="clickedDelete(row.id)">
                            <fa :icon="['fas', 'trash-alt']"/>
                        </el-button>
                        </div>
                    </div>

                    <div v-else-if="field.type == 'float'">
                        {{ getFloating( field, field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ) }}
                    </div>

                    <div v-else-if="field.type == 'number'">
                        {{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ? row[field.key] : 0 }}
                    </div>

                    <div v-else>{{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] }}</div>
                    
                    </template>
                </vxe-table-column>
                </vxe-table>
            </div>
            <div class="footer">
                <div class="result">
                {{ $tc("label.total_record_desc", pagination.max > 0 ? 2 : 1, { row: pagination.item, page: pagination.current, max_page: pagination.max }) }}
                <span>
                    <label>, {{$t('label.show_per_page')}}</label>
                    <select v-model="pagination.perPage"
                    @change="fetchData"
                    >
                    <option v-for="showPerPageOption in getShowPerPage" :key="showPerPageOption.id">{{ showPerPageOption }}</option>
                    </select>
                </span>
                </div>
                <div class="pagination">
                <el-pagination
                    background
                    @current-change="changePage"
                    :current-page.sync="pagination.current"
                    :page-size="1"
                    layout="jumper, prev, pager, next"
                    :total="pagination.max">
                </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import crud from "@/settings/crud";
import PopupEdit from "@/views/custom/PopupEdit";
import { mapState } from 'vuex';

export default {
    props: {
        path: String,
        action: String,
        defaultFilter: Object,
        defaultData: Object
    },
    components: {
        PopupEdit
    },
    async beforeMount() {
        console.warn("beforeMount");
        
        // this.$store.commit("control/setLoad", true);
        this.key = this.path;
        Object.assign(this.currentSetting, this.$setting.crud[this.key]);
        console.log(this.$setting);
        this.pagination.perPage = this.getShowPerPage[0];
        this.currentSetting.fields = [...this.currentSetting.fields.filter(f=>{
            if(f.type == "action-btn") return typeof this.currentSetting.action != "undefined";
            if(f?.hidden?.includes("list")) return false;
            // privilege check
            if(f?.privilege) {
                console.log("privilege", f.privilege);
                let auth = true;
                f.privilege.map(p=>{
                    if(!this.permissions.includes(p)) {
                        console.log("p: ", p);
                        auth = false;
                    }
                });
                console.log("auth: ",auth);
                return auth;
            }
            if(typeof f.hidden == "undefined") return true;
            return true;
        })];
        if(this.defaultFilter != undefined && typeof this.defaultFilter == 'object'){
            Object.keys(this.defaultFilter).map(key=>{
                if(this.currentSetting.filters[key] != undefined){
                    if(this.currentSetting.filters[key].type == "multiselect"){
                        this.filter[key] = [];
                        this.filter[key][0] = this.defaultFilter[key];
                    }
                    else {
                        this.filter[key] = this.defaultFilter[key];
                    }
                }
            });
        }
        if(this.action == 'View'){
            this.currentSetting.action = [];
        }
        await this.fetchData();
        // this.$store.commit("control/setLoad", false);
    },
    methods:{
        closePopupEdit(){
            this.$refs.popupEdit.close();
        },
        create(){
            this.edit(undefined);
        },
        edit(id){
            
            if(typeof id == 'number'){
                this.id=id.toString();
            }
            else {
                this.id=id;
            }
            this.$refs.popupEdit.show();
        },
        async fetchData() {
            this.loading = true;
            
            var params =  {
                size: this.pagination.perPage,
                page: this.pagination.current > 0 ? this.pagination.current - 1 : 0,
                sort_by: this.sort.field ? this.sort.field : this.currentSetting?.sort?.field,
                order: this.sort.order ? this.sort.order : this.currentSetting?.sort?.order,
                ...this.filter,
                trash: this.trashMode == 1 ? 1 : 0
            };
            localStorage.listPage = this.key;
            localStorage.listPageParams = JSON.stringify(params);
            console.log(localStorage);
            await this.$axios.get(`/${this.key}`, {
                params: params
            }).then(res=>{
                let data = res.data.response.dataset;
                this.tableData = data.content.filter(data=>{
                let id = this.currentSetting.id ? this.currentSetting.id : "id";
                if(!data.hasOwnProperty(id)) return true;
                return data[id] > 0;
                });
                this.pagination.max = data.totalPages;
                if(this.pagination.current > this.pagination.max && this.pagination.max > 0) {
                this.pagination.current = this.pagination.max;
                this.fetchData();
                }
                this.pagination.item = data.totalElements;
                this.$refs.table.updateData();
                return true;
            }).catch(err=>{ return false; });
            if(this.currentSetting.options) {
                await this.$axios.get(`options?opts=${Object.keys(this.currentSetting.options).map(key=>this.currentSetting.options[key].key).join("&opts=")}`, {
                params: {
                    // opts: 
                }
                }).then(res=>{
                let options = res.data.response.options;
        
                Object.keys(this.currentSetting.options).filter(opt=>options.hasOwnProperty(this.currentSetting.options[opt].key)).map(opt=>{
                    console.log(opt);
                    let key = this.currentSetting.options[opt].key;
                    this.options[key] = options[key].map(value=>{
                    return {
                        label: typeof value == "object" ? value[this.currentSetting.options[opt].label] : value,
                        value: typeof value == "object" ? value[this.currentSetting.options[opt].value] : value,
                    }
                    });
                });
                return true;
                }).catch(err=>{ return false; });
            }
            console.log(this.options)
            // datatype: id
            let fieldTypeId = this.currentSetting.fields.filter(f=>f?.datatype=="id").map(f=>f.key);
            this.tableData.map((data,i)=>{
                Object.keys(data).filter(d=>fieldTypeId.includes(d)).map(key=>{
                console.log("key: ",key);
                let opt_key = this.currentSetting.options[key].key;
                let obj = this.options[opt_key].find(obj=>obj.value==this.tableData[i][key]);
                console.log("obj: ",obj);
                this.tableData[i][key] = obj.label;
                });
            });


            this.loading = false;
            return true;
        },
        filterChanged({datas, column}) {
            console.warn("column: ",column);
            console.warn("filter changed: ",datas);
            let field_setting = this.currentSetting.fields.hasOwnProperty(column.property) ? this.currentSetting.fields[column.property] : {};
            let filter_setting = this.currentSetting.filters.hasOwnProperty(column.property) ? this.currentSetting.filters[column.property] : {};

            if(filter_setting.type == "daterange") {
                this.filter[column.property] = datas.length > 0 ? datas[0].map((data,index)=>{
                if(index == 0) {
                    return this.$moment(data).unix();
                }else if(index == 1) {
                    // make sure it is 23:59:59
                    return this.$moment(data).add(1, "days").unix();
                }
                }) : undefined;
            } else if (filter_setting.type == "boolean"){
                this.filter[column.property] = datas.length > 0 ? datas[0] : 0;
            } else {
                this.filter[column.property] = datas.length > 0 ? datas[0] : undefined;
            }
            // this.fetchData();
            this.$forceUpdate();
        },
        sortChanged({column, property, order, $event}) {
            console.log("column: ",column);
            console.log("property: ",property);
            console.log("order: ",order);
            console.log("$event: ",$event);
            this.sort.field = property;
            this.sort.order = order;
            this.fetchData();
        },
        clickedCell({ rowIndex }) {
            this.selected_row = rowIndex;
        },
        changePage(page) {
            this.selected_row = -1;
            this.pagination.current = page;
            this.fetchData();
        },
        clickedCell({ rowIndex }) {
            this.selected_row = rowIndex;
        },
        changePage(page) {
            this.selected_row = -1;
            this.pagination.current = page;
            this.fetchData();
        },
        hasRightToCreate() {
            return this.permissions.includes(`CREATE_${this.currentSetting.key}`.toUpperCase());
        },
        hasRightToEdit() {
            return this.currentSetting.action && this.currentSetting.action.includes('edit') && this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase());
        },
        hasRightToDelete() {
            if(this.permissions.includes(`READ_DELETE`.toUpperCase())){
                return this.currentSetting.action && this.currentSetting.action.includes('delete') && this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase());
            }
            return false;
        },
        filterRender(key) {
        
            if(typeof this.currentSetting.filters == 'undefined') return;

            let currentFilterObj = {};
            if (!this.currentSetting.filters[key]?.type){
                currentFilterObj = { name:'FilterInput' };
            }

            let filterType = this.currentSetting.filters[key]?.type;

            if ( filterType == 'multiselect' || filterType == 'select' ) {
                currentFilterObj = {
                    name: this.filter_type_mapping[filterType],
                    options: this.options[this.currentSetting.options[key].key],
                };
            }

            if ( filterType == 'daterange' ) {
                currentFilterObj = {
                    name: this.filter_type_mapping[filterType],
                    options: [],
                    props: {type: 'daterange', format: 'yyyy-MM-dd'},
                    filterable: this.currentSetting.filters.filterable
                };
            }

            if ( filterType == 'boolean' ) {
                currentFilterObj = {
                    name: this.filter_type_mapping[filterType],
                };
            }

            if(this.filter[key]){
                currentFilterObj.selectedOptions = this.filter[key];
            }

            return currentFilterObj;

        },
        shouldHighlight({ rowIndex }) {
            if(rowIndex == this.selected_row) {
                return "row-clicked";
            }
        },
        onFilterMouseOver(key) {
            if(this.effect.mouse_over == key) return;
            if(typeof this.filter[key] == "undefined") return;
            this.effect.mouse_over = key;
        },
        onFilterMouseLeave() {
            if(this.effect.mouse_over == null) return;
            this.effect.mouse_over = null;
        },
        async clickedDelete(id){
            var _this = this;
            var data = undefined;
            var msg = "";
            try {
                data = (await this.$axios.get(`/${this.key}/checkDelete/${id}`)).data;
            } catch (error) {}

            if(data?.msgCode){
                msg = _this.$t(`message.${data?.msgCode}`)
            }
            let confirm = await _this.$confirm( msg, _this.$tc("message.confirm_to_delete",null,{ id: id }), {
                confirmButtonText: _this.$t("message.confirm"),
                cancelButtonText: _this.$t("message.cancel"),
                type: 'warning'
            }).catch(()=>{return false;});
            if(confirm) {
                _this.deleted(id);
            }
        },
        async deleted(id) {
            // let confirm = await this.$confirm(this.$tc("message.confirm_to_delete",null,{ id: id }) , '', {
            //   confirmButtonText: this.$t("message.confirm"),
            //   cancelButtonText: this.$t("message.cancel"),
            //   type: 'warning'
            // }).catch(()=>{return false;});;
            // if(!confirm) return;
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // if cancel, then break
            if(!confirm) return;

            await this.$axios.delete(`/${this.key}/${id}`).then(res=>{
                console.log(res)
                if(res.data == 'Deleted'){
                    this.fetchData();
                }
                else {
                this.$message({
                    message: "Delete error",
                    type: 'error'
                });
                }

                return true;
            }).catch(err=>{
                console.error(err);
                return false;
            });
            loading.close();
        },
        
    },
    computed: {
        ...mapState({
            permissions: state => state.user.user_info.permissions
        }),
        
        getShowPerPage() {
            const perPageSetting = [10,20,50,100];
            if (Array.isArray(perPageSetting)){
                return perPageSetting;
            }
            if (typeof perPageSetting == "object") {
                const min = perPageSetting.min;
                const max = perPageSetting.max;
                const step = perPageSetting.step;

                let tranformedPerPageSetting = [];
                let initOption = min;
                for(let i = 0; i <= (max-min)/step; i++) {
                tranformedPerPageSetting.push(initOption);
                initOption+= step;
                }
                return tranformedPerPageSetting;
            } 
            return [20,50,100,200];
        },
    },
    data() {
        return {
            key: "",
            id:undefined,
            currentSetting: {},
            tableData: [],
            filter: {},
            loading: false,
            trashMode: 0,
            pagination: {
                perPage: 0,
                total: 0,
                current: 1,
                item: 0,
                max: 0
            },
            sort: {
                field: "",
                order: ""
            },
            filter_type_mapping: {
                text: "ElInput",
                select: "FilterSelect",
                boolean: "FilterSwitch",
                daterange: "FilterDaterange",
                multiselect: "FilterMultiSelect"
            },
            options: {},
            tag: {},
            selected: 0,
            selected_row: -1,
            effect: {
                mouse_over: null
            }
        }
    },

}
</script>

<style lang="scss">
.custom_list{
    width: 100%;
    .popup-edit{
        // max-width: 800px;
    }
    .content{
        .main-table{
            .detect-block{
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
            }
            zoom: .9;
            th,td{
                // zoom: .7;
            }
            .vxe-cell{
                padding-left: 5px;
                padding-right: 5px;
            }
        }
        .el-tabs{
            .el-tabs__header{
                margin-bottom: 0px;
            }
            .el-tabs__item{
                height: 30px;
                line-height: 30px;
            }
        }
        .tab-content{
            .filter-table{
                margin-bottom: 10px;
                .el-tag{
                // display: flex;
                margin-right: 5px;
                .label,
                .value{
                    display: inline-block;
                }
                .label{
                    margin-right: 5px;
                    // font-size: xx-small;
                }
                .value{
                    font-weight: bold;
                    font-size: small;
                }

                &.other{
                    opacity: .4;
                }
                &.current{
                    opacity: 1;
                }
                }
            }
        }
        .vxe-table--header{
            .vxe-cell{
                font-size: 12px;
            }
        }
        .vxe-table--body{
            .row-clicked{
                background: #ffe48d;
            }
            .vxe-cell{
                font-size: 12px;
            }
            .action{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .el-button{
                padding: 7px 7px;
                }
                & div > *:not(:first-child){
                margin-left: 5px;
                }
            }
        }
        .action-btn{
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            & > *:not(:first-child){
                margin-left: 10px;
            }
        }
        .el-checkbox{
            position: relative;
        }
        .block-layer{
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 1;
        }
        .header-wrap{
            line-height: 1.2;
            .filter-value{
                font-size: .5rem;
                color: blue;
            }
            .search{
                display: flex;
                input{
                width: 100%;
                }
            }
        }
        .footer{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .result{
                font-size: small;
            }
            .pagination{
                display: flex;
                margin-top: 10px;
                justify-content: flex-end;
                .page{
                    font-size: x-small;
                    cursor: pointer;
                    user-select: none;
                    width: 25px;
                    height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #c5e1ff;
                    border-color: #c5e1ff;
                    color: white;
                    &:not(:last-child) {
                        margin-right: 10px;
                    }
                    &.current{
                        background-color: #409EFF;
                        border-color: #409EFF;
                    }
                }
            }
        }
    }
}
</style>